import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { isNative } from '../utils/platform';

const DISMISS_KEY = 'appNudgeDismissed';
const APP_STORE_URL = 'https://apps.apple.com/us/app/smpw-scheduler/id6762612656';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=io.github.branleeharris.smpwscheduler';

function detectTarget() {
  const ua = navigator.userAgent || '';
  const params = new URLSearchParams(window.location.search);
  const override = params.get('nudge');
  if (override === 'ios') return 'ios';
  if (override === 'android') return 'android';

  const isIOS =
    /iPhone|iPad|iPod/.test(ua) ||
    (ua.includes('Mac') && navigator.maxTouchPoints > 1);
  if (isIOS) return 'ios';

  const isAndroid = /Android/i.test(ua);
  if (isAndroid) return 'android';

  return null;
}

export default function AppNudge({ darkMode = false }) {
  const { t } = useTranslation();
  const [target, setTarget] = useState(null);

  useEffect(() => {
    if (isNative()) return;
    try {
      if (localStorage.getItem(DISMISS_KEY) === '1') return;
    } catch {}
    setTarget(detectTarget());
  }, []);

  if (!target) return null;

  const storeUrl = target === 'android' ? PLAY_STORE_URL : APP_STORE_URL;
  const tagline = target === 'android' ? t('nudge.freeAndroid') : t('nudge.free');

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {}
    setTarget(null);
  };

  return (
    <div
      className={`border-b ${
        darkMode
          ? 'bg-surface-950/95 border-gray-800/60'
          : 'bg-white/95 border-gray-200/70'
      } backdrop-blur-xl`}
    >
      <div className="max-w-6xl mx-auto px-3 sm:px-4 py-2 flex items-center gap-3">
        <img
          src={`${process.env.PUBLIC_URL}/logo192.png`}
          alt=""
          className="h-9 w-9 rounded-lg shadow-sm shrink-0"
        />
        <div className="flex-1 min-w-0 leading-tight">
          <div
            className={`text-sm font-semibold truncate ${
              darkMode ? 'text-gray-100' : 'text-gray-900'
            }`}
          >
            SMPW Scheduler
          </div>
          <div
            className={`text-xs truncate ${
              darkMode ? 'text-gray-400' : 'text-gray-500'
            }`}
          >
            {tagline}
          </div>
        </div>
        <a
          href={storeUrl}
          className="shrink-0 inline-flex items-center rounded-full bg-brand-600 hover:bg-brand-700 active:scale-95 transition px-4 py-1.5 text-xs font-semibold text-white shadow-sm"
        >
          {t('nudge.view')}
        </a>
        <button
          onClick={dismiss}
          aria-label={t('nudge.dismiss')}
          className={`shrink-0 p-1 rounded-full transition ${
            darkMode
              ? 'text-gray-500 hover:text-gray-300 hover:bg-gray-800'
              : 'text-gray-400 hover:text-gray-600 hover:bg-gray-100'
          }`}
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
